import React, { Component } from 'react'

export class Account extends Component {
  render() {
    return (
      <div>
        A
      </div>
    )
  }
}

export default Account
